import React from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaArrowLeft, FaCheck, FaBell, FaHeart, FaStar } from 'react-icons/fa';

export default function WhatsApp() {
  const whatsappNumber = "+18493762882";
  const whatsappUrl = `https://wa.me/${whatsappNumber.replace('+', '')}?text=Hello`;

  const handleWhatsAppClick = () => {
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-green-50 py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* WhatsApp Green Orbs */}
        <div className="absolute top-20 left-10 w-32 h-32 bg-green-400/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-green-500/10 rounded-full blur-3xl animate-pulse animation-delay-2000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-green-300/5 rounded-full blur-3xl animate-pulse animation-delay-4000"></div>
        
        {/* Floating WhatsApp Icons */}
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="absolute text-green-200/20 animate-float"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              fontSize: `${Math.random() * 2 + 1}rem`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${8 + Math.random() * 4}s`
            }}
          >
            <FaWhatsapp />
          </div>
        ))}
      </div>

      <div className="max-w-2xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-8">
          <Link
            to="/dashboard"
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6 transition-colors duration-200"
          >
            <FaArrowLeft className="w-4 h-4 mr-2" />
            Back to Dashboard
          </Link>
          
          <div className="mb-6">
            <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg transform hover:scale-105 transition-all duration-300">
              <FaWhatsapp className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-2">WhatsApp Notifications</h1>
            <p className="text-lg text-gray-600 max-w-md mx-auto">
              Get instant updates about new content, learning tips, and exclusive offers
            </p>
          </div>
        </div>

        {/* Main Card */}
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-200">
          {/* Header Section */}
          <div className="bg-gradient-to-r from-green-500 to-green-600 p-8 text-center">
            <FaBell className="w-12 h-12 text-white mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-white mb-2">Join Our WhatsApp Community</h2>
            <p className="text-green-100">
              Connect with thousands of learners and never miss an update
            </p>
          </div>

          {/* Content Section */}
          <div className="p-8 text-center">
            <div className="mb-8">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">How to Subscribe:</h3>
              <div className="space-y-4">
                <div className="flex items-center justify-center space-x-4 p-4 bg-green-50 rounded-xl border border-green-200">
                  <div className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center font-bold">1</div>
                  <span className="text-gray-700">Click the WhatsApp button below</span>
                </div>
                <div className="flex items-center justify-center space-x-4 p-4 bg-green-50 rounded-xl border border-green-200">
                  <div className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center font-bold">2</div>
                  <span className="text-gray-700">Send a simple "Hello" message</span>
                </div>
                <div className="flex items-center justify-center space-x-4 p-4 bg-green-50 rounded-xl border border-green-200">
                  <div className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center font-bold">3</div>
                  <span className="text-gray-700">You're subscribed! Start receiving updates</span>
                </div>
              </div>
            </div>

            {/* WhatsApp Button */}
            <div className="mb-8">
              <button
                onClick={handleWhatsAppClick}
                className="group relative inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-2xl font-bold text-lg hover:from-green-600 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-green-500/25 overflow-hidden"
              >
                {/* Button Background Animation */}
                <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-green-400 to-green-500 opacity-0 group-hover:opacity-30 group-active:opacity-50 transition-opacity duration-300"></span>
                
                {/* Button Content */}
                <span className="relative flex items-center">
                  <FaWhatsapp className="mr-3 w-6 h-6" />
                  Subscribe via WhatsApp
                  <span className="ml-2 text-sm opacity-80">→</span>
                </span>
              </button>
              
              <p className="mt-4 text-sm text-gray-500">
                Opens WhatsApp with a pre-filled "Hello" message to {whatsappNumber}
              </p>
            </div>

            {/* Benefits Section */}
            <div className="bg-green-50 rounded-2xl p-6 border border-green-200">
              <h3 className="font-semibold text-gray-900 mb-4 flex items-center justify-center">
                <FaWhatsapp className="w-5 h-5 text-green-500 mr-2" />
                What you'll receive:
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <FaCheck className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">New song releases and featured content</span>
                </li>
                <li className="flex items-start">
                  <FaCheck className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">Learning tips and language practice reminders</span>
                </li>
                <li className="flex items-start">
                  <FaCheck className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">Exclusive offers and early access to new features</span>
                </li>
                <li className="flex items-start">
                  <FaCheck className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">Weekly progress updates and achievements</span>
                </li>
              </ul>
            </div>

            {/* Privacy Notice */}
            <div className="mt-6 bg-gray-50 rounded-xl p-4 border border-gray-200">
              <p className="text-sm text-gray-600 text-center">
                🔒 Your privacy is important to us. We only send relevant learning content. 
                You can unsubscribe at any time by replying "STOP" to any message.
              </p>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-8 text-center">
          <div className="bg-white/80 backdrop-blur-lg rounded-2xl p-6 border border-white/20 shadow-lg">
            <h3 className="font-semibold text-gray-900 mb-3">Why WhatsApp Notifications?</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-gray-600">
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-2">
                  <FaBell className="w-6 h-6 text-green-500" />
                </div>
                <span className="font-medium">Instant Updates</span>
                <span className="text-xs text-center">Get notified immediately when new content is available</span>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-2">
                  <FaWhatsapp className="w-6 h-6 text-green-500" />
                </div>
                <span className="font-medium">Convenient</span>
                <span className="text-xs text-center">Receive updates on the app you already use daily</span>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-2">
                  <FaCheck className="w-6 h-6 text-green-500" />
                </div>
                <span className="font-medium">No Spam</span>
                <span className="text-xs text-center">Only relevant content, unsubscribe anytime</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Styles */}
      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px) rotate(0deg);
          }
          25% {
            transform: translateY(-10px) rotate(5deg);
          }
          50% {
            transform: translateY(0px) rotate(0deg);
          }
          75% {
            transform: translateY(-5px) rotate(-5deg);
          }
        }
        
        .animate-float {
          animation: float 8s ease-in-out infinite;
        }
        
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </div>
  );
}